export interface CreditsPrivacyButton {
  urlWebSite: string;
  companyLogo:string;
  text:string;
}
